import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-[#CCCCCC] bg-[#F5F5F5] px-3 py-2 text-sm text-[#333B44] ring-offset-background placeholder:text-[#999999] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3BAFDA] focus-visible:border-[#3BAFDA] focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
